"use strict";
import { extractZipCode } from "./address_verification_utils";
export class AddressVerificationComponent {
  constructor(node) {
    this.node = node;
    this.queryField = this.getQueryField();
    this.model = this.getModel();
    this.addressType = this.getAddressType();
  }
  getNodeName() {
    return this.node.getAttribute("name");
  }
  setNodeValue(value) {
    const elementType = this.node.tagName.toLowerCase();
    this.node.value = value;
  }
  getNodeValue() {
    return this.node.value;
  }
  getQueryField() {
    return this.node.getAttribute("data-query-field");
  }
  getModel() {
    return this.node.getAttribute("data-address-model");
  }
  getAddressType() {
    return this.node.getAttribute("data-address-type");
  }
}
export class AddressVerificationAddressGroup {
  constructor(nodes) {
    this.queryFieldsForUSAddresses = ["country", "street", "city", "state", "zipcode"];
    this.nodes = nodes;
    this.productType = this.getProductType();
    this.addressVerificationFields = {
      addressVerificationRecordId: null,
      selectedCandidateIndex: null
    };
    this.addressGroupPrefix = this.setAddressGroupPrefix() || null;
  }
  setAddressGroupPrefix() {
    if (Object.values(this.nodes).length === 0) return null;
    const formBuilderSectionNode = Object.values(this.nodes)[0].node.closest('[data-node-type="section"]');
    if (!formBuilderSectionNode) return null;
    return this.getSectionTitle(formBuilderSectionNode);
  }
  getSectionTitle(formBuilderSectionNode) {
    const heading = formBuilderSectionNode.getAttribute("heading");
    if (heading) return heading.trim();
    const sectionTitle = formBuilderSectionNode.querySelector(".fb_section_title")?.textContent;
    if (!sectionTitle) return null;
    return sectionTitle.trim();
  }
  getProductType() {
    const countryNode = Object.values(this.nodes).find((node) => node.getQueryField() === "country");
    return countryNode?.getNodeValue() === "United States" ? "usa" : "international";
  }
  areAllAddressVerificationFieldsPresentAndHaveValues() {
    const nodesWithValues = Object.values(this.nodes).filter((node) => {
      const value = node.getNodeValue();
      return value != null && String(value).trim() !== "";
    });
    const presentFieldsWithValues = nodesWithValues.map((node) => node.getQueryField());
    const requiredFields = ["country", "street"];
    const hasAllRequired = requiredFields.every((field) => presentFieldsWithValues.includes(field));
    const optionalFields = ["city", "state", "zipcode"];
    const optionalFieldCount = optionalFields.filter((field) => presentFieldsWithValues.includes(field)).length;
    const hasAtLeastTwoOptional = optionalFieldCount >= 2;
    return hasAllRequired && hasAtLeastTwoOptional;
  }
  getModel() {
    const model = Object.values(this.nodes)[0].getModel();
    return model;
  }
  getAddressType() {
    const addressType = Object.values(this.nodes)[0].getAddressType();
    return addressType;
  }
  getQueryFields() {
    return Object.values(this.nodes).reduce((acc, node) => {
      acc[node.getQueryField()] = node.getNodeValue();
      return acc;
    }, {});
  }
  buildParamsForAddressVerification() {
    return {
      queryParams: this.getQueryFields(),
      model: this.getModel(),
      addressType: this.getAddressType(),
      addressGroupPrefix: this.addressGroupPrefix
    };
  }
  updateAddressVerificationRecordId(addressVerificationRecordId) {
    this.addressVerificationFields.addressVerificationRecordId = addressVerificationRecordId;
  }
  getAddressVerificationRecordId() {
    return this.addressVerificationFields.addressVerificationRecordId;
  }
  updateSelectedCandidateIndex(selectedCandidateIndex) {
    this.addressVerificationFields.selectedCandidateIndex = selectedCandidateIndex;
  }
  updateAddressFieldsWithSelectedCandidate(selectedCandidate) {
    const selectedCandidateIndex = selectedCandidate.candidate_index;
    this.updateSelectedCandidateIndex(selectedCandidateIndex);
    const fieldMapping = {
      "street": selectedCandidate.AddressLine1,
      "secondary": selectedCandidate.AddressLine2 || "",
      "city": selectedCandidate.City,
      "state": selectedCandidate.labels_for_view.state,
      "zipcode": extractZipCode(selectedCandidate.PostalCode)
    };
    Object.entries(fieldMapping).forEach(([queryField, value]) => {
      const node = Object.values(this.nodes).find((node2) => node2.getQueryField() === queryField);
      if (!node) return;
      node.setNodeValue(value);
    });
  }
  getSelectedCandidateIndex() {
    return this.addressVerificationFields.selectedCandidateIndex;
  }
}
